import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useLazyQuery } from "@apollo/react-hooks";
import { hasuraClient } from "../../apolloClient";
import All from "./EventTab";
import { Tab, Nav } from "react-bootstrap";
import MainContainer from "../../container/MainContainer";
import { GET_ALL_EVENTS } from "../../query/GetEvents";
import moment from "moment";

const EventLayout = () => {
  const [
    getAllEvents,
    {
      data: data,
      refetch: refetchEvents,
      loading: allEventLoading,
      error: allEventError,
    },
  ] = useLazyQuery(GET_ALL_EVENTS, {
    client: hasuraClient,
    variables: {
      profile_id: localStorage.getItem("profile_id"),
      currentDateTime: moment().format(),
    },
  });

  useEffect(() => {
    getAllEvents();
  }, []);

  return (
    <MainContainer active="events">
      <section className="post-block">
        <div className="main-title">
          <h1>Event</h1>
          <div class="post-button">
            <Link to="/create-event" className="button">
              Create Event
            </Link>
          </div>
        </div>
        <div className="post-tab">
          <Tab.Container id="left-tabs-example" defaultActiveKey="All">
            <Nav variant="pills" className="flex-column">
              <Nav.Item>
                <Nav.Link eventKey="All">
                  <span className="tab-name">All</span>
                  <span className="count">
                    {data ? data.all_count.aggregate.count : null}
                  </span>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="Published">
                  <span className="tab-name">Upcoming</span>
                  <span className="count">
                    {data ? data.upcoming_count.aggregate.count : null}
                  </span>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="Drafts">
                  <span className="tab-name">Past</span>
                  <span className="count">
                    {data ? data.past_count.aggregate.count : null}
                  </span>
                </Nav.Link>
              </Nav.Item>
            </Nav>

            <Tab.Content>
              <Tab.Pane eventKey="All">
                <All
                  data={data ? data.all_event : null}
                  refetch={refetchEvents}
                  loading={allEventLoading}
                  error={allEventError}
                />
              </Tab.Pane>
              <Tab.Pane eventKey="Published">
                <All
                  data={data ? data.upcoming_event : null}
                  refetch={refetchEvents}
                  loading={allEventLoading}
                  error={allEventError}
                />
              </Tab.Pane>
              <Tab.Pane eventKey="Drafts">
                <All
                  data={data ? data.past_event : null}
                  refetch={refetchEvents}
                  loading={allEventLoading}
                  error={allEventError}
                />
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
      </section>
    </MainContainer>
  );
};

export default EventLayout;
